module.exports = __webpack_public_path__ + "static/trump-a4e82605368fd330780002007cf7d31d.png";